/***********************************************
 *   SNAKE V 1.0.0 - 2020 Mexico City
 *         V 1.1.0 - 31/Mar/2026 Mexico City
 *         V 1.2.0 - Two-Player Support
 ***********************************************/
var canvas = document.getElementById('game-panel');
document.addEventListener("keypress", onPressKey);
document.addEventListener("keydown", onPressKey);
var ctx = canvas.getContext('2d');

// Touch control variables
var touchStartX = 0;
var touchStartY = 0;
var touchEndX = 0;
var touchEndY = 0;
var minSwipeDistance = 30;

// Add touch event listeners
canvas.addEventListener('touchstart', handleTouchStart, false);
canvas.addEventListener('touchend', handleTouchEnd, false);

var txS = document.getElementById('txScore');
var txSpeed = document.getElementById('txSpeed');

var ch = 400;
var cw = 480;

var frameSpeed = 200;
var snakeWidth = 10;
var snakeSpace = 1;
var CELL_INDEX = {
    X: 0,
    Y: 1,
    WIDTH: 2,
    HEIGHT: 3,
    DIRECTION: 4
};
var DIRECTION = {
    TOP: 1,
    LEFT: 2,
    BOTTOM: 3,
    RIGHT: 4
};
var DEFAULT_DIRECTION = DIRECTION.RIGHT;
var startSnakeSize = 3;
canvas.width = cw;
canvas.height = ch;
var spx = cw / 2;
var spy = ch / 2;
var nsn = undefined;

var pause = false;
var crash = false;
var crashedSnakeIndex = -1; // Track which snake crashed
var crossMode = true;
var player2Enable = false;
var gameStarted = false;
var speed = 0;
var snakes = [];
var ctl_wasd = [119, 97, 115, 100]; // WASD
var ctl_arrows = [38, 37, 40, 39]; // Arrow keys

const GAME_OVER_TEXT = "Game over!";
const PAUSE_TEXT = "Pause!";

/***********************************************
 *   START
 ***********************************************/
init();
buildNewSlotSnake();

var frameint = setInterval(function() {
    frame();
}, frameSpeed);

function frame() {
    if (!pause) {
        if (!crash) {
            checkEat();
            checkCollision();
            drawBackground();
            for (const snake of snakes) {
                snake.draw();
            }
            drawNewSlotSnake();
            txSpeed.innerHTML = Math.ceil(5000 / frameSpeed);
        } else {
            drawTextOver(GAME_OVER_TEXT);
        }
    } else {
        drawTextOver(PAUSE_TEXT);
    }

    // CROSS MODE
    if (crossMode) {
        crossModeAllowed();
    }
}

/***********************************************
 *   UTIL
 ***********************************************/
function addClass(elementId, className) {
    let element = document.getElementById(elementId);
    if (element) {
        let clss = element.className;
        element.className = clss + ' ' + className;
    }
}

function removeClass(elementId, className) {
    let element = document.getElementById(elementId);
    if (element) {
        let clss = element.className;
        element.className = clss.replace(className, '');
    }
}

function resetFrame() {
    window.clearInterval(frameint);
    frameint = setInterval(function() {
        frame();
    }, frameSpeed);
}

function isMobileView() {
    return window.innerWidth <= 768;
}

function init() {
    snakes = [];
    
    // Clean enables
    for (const el_id of ['cross-mode-id', 'two-mode-id', 'box-mode-id']) {
        removeClass(el_id, 'enable');
    }

    // Snake positions
    spx = cw / 2;
    spy = ch / 2;

    // Player 1 - Green snake
    snakes.push(new Snake('#00FF00', ctl_wasd, spx, spy));

    // Player 2 - Blue snake (only if enabled and not mobile)
    if (player2Enable && !isMobileView()) {
        snakes.push(new Snake('#2A55FF', ctl_arrows, spx, spy + 20));
        removeClass('ctrl-p2', 'hidden');
        addClass('ctrl-p2', 'show');
        addClass('two-mode-id', 'enable');
    } else {
        removeClass('ctrl-p2', 'show');
        addClass('ctrl-p2', 'hidden');
        // Force disable player 2 on mobile
        if (isMobileView()) {
            player2Enable = false;
        }
    }

    // Cross-mode
    if (crossMode) {
        addClass('cross-mode-id', 'enable');
        updateModeLabel('CROSS MODE', 'On this mode you can cross the walls.');
    } else {
        // Box-mode
        addClass('box-mode-id', 'enable');
        updateModeLabel('BOX MODE', 'On this mode you can\'t cross the walls be careful');
    }

    nsn = undefined;
    buildNewSlotSnake();
    crash = false;
    crashedSnakeIndex = -1; // Reset crashed snake tracker
    gameStarted = true;
}

function updateModeLabel(modeTitle, modeDesc) {
    var modeLabels = document.querySelectorAll('.lb-mode');
    if (modeLabels.length >= 1) {
        modeLabels[0].innerHTML = modeTitle;
    }
    if (modeLabels.length >= 2) {
        modeLabels[1].innerHTML = modeDesc;
    }
}

function checkCollision() {
    for (var idx = 0; idx < snakes.length; idx++) {
        var snake = snakes[idx];
        
        // Check self-collision
        for (var i = 1; i < snake.cells.length; i++) {
            if (snake.cells[0][0] == snake.cells[i][0] && 
                snake.cells[0][1] == snake.cells[i][1]) {
                console.log("crash with self!");
                crash = true;
                crashedSnakeIndex = idx;
            }
        }
        
        // Check wall collision in box mode
        if (!crossMode) {
            if (snake.cells[0][0] < 0 || snake.cells[0][0] >= cw ||
                snake.cells[0][1] < 0 || snake.cells[0][1] >= ch) {
                console.log("crash with wall!");
                crash = true;
                crashedSnakeIndex = idx;
            }
        }
    }
}

function checkEat() {
    for (const snake of snakes) {
        if ((nsn[0] == snake.cells[0][0] && nsn[1] == snake.cells[0][1]) ||
            (nsn[0] == snake.cells[1][0] && nsn[1] == snake.cells[1][1])) {
            var n = JSON.parse(JSON.stringify(snake.cells[snake.cells.length - 1]));
            switch (n[4]) {
                case 4:
                    n[0] = n[0] - snakeWidth;
                    break;
                case 3:
                    n[1] = n[1] - snakeWidth;
                    break;
                case 2:
                    n[0] = n[0] + snakeWidth;
                    break;
                case 1:
                    n[1] = n[1] + snakeWidth;
                    break;
            }
            snake.cells.push(n);
            buildNewSlotSnake();
        }
    }
}

function buildSnake(size, x, y) {
    var b = [];
    for (var i = 0; i < size; i++) {
        b[i] = [
            snakeWidth * i * -1 + x,
            y,
            snakeWidth,
            snakeWidth,
            DIRECTION.RIGHT
        ];
    }
    return b;
}

function buildNewSlotSnake() {
    var rand_x = Math.ceil((Math.random() * cw) / snakeWidth) * snakeWidth - snakeWidth;
    var rand_y = Math.ceil((Math.random() * ch) / snakeWidth) * snakeWidth - snakeWidth;
    if (rand_x != 0 && rand_x != cw - snakeWidth &&
        rand_y != 0 && rand_y != ch - snakeWidth) {
        nsn = [rand_x, rand_y, snakeWidth, snakeWidth, 4];
    } else {
        buildNewSlotSnake();
    }
}

var crossModeAllowed = function() {
    for (const snake of snakes) {
        for (const cell of snake.cells) {
            if (cell[CELL_INDEX.X] == cw - snakeWidth && 
                cell[CELL_INDEX.DIRECTION] == DIRECTION.RIGHT) {
                cell[CELL_INDEX.X] = -snakeWidth;
            } else if (cell[CELL_INDEX.Y] == ch - snakeWidth && 
                       cell[CELL_INDEX.DIRECTION] == DIRECTION.BOTTOM) {
                cell[CELL_INDEX.Y] = -snakeWidth;
            } else if (cell[CELL_INDEX.X] == CELL_INDEX.X && 
                       cell[CELL_INDEX.DIRECTION] == DIRECTION.LEFT) {
                cell[CELL_INDEX.X] = cw;
            } else if (cell[CELL_INDEX.Y] == 0 && 
                       cell[CELL_INDEX.DIRECTION] == DIRECTION.TOP) {
                cell[CELL_INDEX.Y] = ch;
            }
        }
    }
};

/***********************************************
 *   EVENTS
 ***********************************************/
function onMode(mode) {
    console.log("mode " + mode);
    if (mode === 'cross') {
        crossMode = true;
    } else if (mode == 'two') {
        // Prevent enabling two-player mode on mobile
        if (isMobileView()) {
            alert('Two-player mode is only available on desktop. Please use a larger screen.');
            return;
        }
        player2Enable = !player2Enable;
    } else if (mode === 'box') {
        crossMode = false;
    }

    onReset();
}

function onUpSpeed() {
    if (frameSpeed > 10) {
        frameSpeed = frameSpeed - 10;
        resetFrame();
    }
}

function onDownSpeed() {
    frameSpeed = frameSpeed + 10;
    resetFrame();
}

function onRandom() {
    nsn = undefined;
    buildNewSlotSnake();
}

function onReset() {
    init();
    frameSpeed = 200;
    resetFrame();
}

function onPause() {
    pause = !pause;
    if (pause) {
        addClass('pause-id', 'enable');
    } else {
        removeClass('pause-id', 'enable');
    }
}

function onPressKey(evt) {
    for (i in snakes) {
        snakes[i].control(evt);
    }
}

/***********************************************
 *   TOUCH CONTROLS (Player 1 only)
 ***********************************************/
function handleTouchStart(evt) {
    evt.preventDefault();
    const firstTouch = evt.touches[0];
    touchStartX = firstTouch.clientX;
    touchStartY = firstTouch.clientY;
}

function handleTouchEnd(evt) {
    evt.preventDefault();
    touchEndX = evt.changedTouches[0].clientX;
    touchEndY = evt.changedTouches[0].clientY;
    handleSwipe();
}

function handleSwipe() {
    // Only control Player 1 with touch
    if (snakes.length === 0) return;
    
    var deltaX = touchEndX - touchStartX;
    var deltaY = touchEndY - touchStartY;
    
    if (Math.abs(deltaX) < minSwipeDistance && Math.abs(deltaY) < minSwipeDistance) {
        return;
    }
    
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
        if (deltaX > 0) {
            // Swipe right
            if (snakes[0].cells[0][4] != 2)
                snakes[0].cells[0][4] = 4;
        } else {
            // Swipe left
            if (snakes[0].cells[0][4] != 4)
                snakes[0].cells[0][4] = 2;
        }
    } else {
        if (deltaY > 0) {
            // Swipe down
            if (snakes[0].cells[0][4] != 1)
                snakes[0].cells[0][4] = 3;
        } else {
            // Swipe up
            if (snakes[0].cells[0][4] != 3)
                snakes[0].cells[0][4] = 1;
        }
    }
}

/***********************************************
 *   MODEL - Snake Class
 ***********************************************/
function Snake(color, keys, x, y) {
    this.x = x;
    this.y = y;
    this.cells = buildSnake(startSnakeSize, x, y);
    this.color = color;
    this.keys = keys;
    
    this.control = function(evt) {
        if (evt.keyCode == this.keys[0]) { // W or Up
            if (this.cells[0][4] != 3) this.cells[0][4] = 1;
        } else if (evt.keyCode == this.keys[1]) { // A or Left
            if (this.cells[0][4] != 4) this.cells[0][4] = 2;
        } else if (evt.keyCode == this.keys[2]) { // S or Down
            if (this.cells[0][4] != 1) this.cells[0][4] = 3;
        } else if (evt.keyCode == this.keys[3]) { // D or Right
            if (this.cells[0][4] != 2) this.cells[0][4] = 4;
        }
    };
    
    this.draw = function() {
        ctx.fillStyle = color;
        for (const cell of this.cells) {
            switch (cell[CELL_INDEX.DIRECTION]) {
                case DIRECTION.RIGHT:
                    cell[CELL_INDEX.X] = cell[CELL_INDEX.X] + snakeWidth;
                    break;
                case DIRECTION.BOTTOM:
                    cell[CELL_INDEX.Y] = cell[CELL_INDEX.Y] + snakeWidth;
                    break;
                case DIRECTION.LEFT:
                    cell[CELL_INDEX.X] = cell[CELL_INDEX.X] - snakeWidth;
                    break;
                case DIRECTION.TOP:
                    cell[CELL_INDEX.Y] = cell[CELL_INDEX.Y] - snakeWidth;
                    break;
            }
            ctx.fillRect(
                cell[CELL_INDEX.X],
                cell[CELL_INDEX.Y],
                snakeWidth - snakeSpace,
                snakeWidth - snakeSpace
            );
        }
        for (var j = this.cells.length - 1; j > 0; j--) {
            if (this.cells[j][4] != this.cells[j - 1][4]) {
                this.cells[j][4] = this.cells[j - 1][4];
            }
        }
    };
    
    return this;
}

/***********************************************
 *   DRAW
 ***********************************************/
function drawNewSlotSnake() {
    ctx.fillStyle = "#FF002A";
    ctx.fillRect(nsn[0], nsn[1], snakeWidth, snakeWidth);
}

function drawTextOver(text) {
    ctx.fillStyle = "#FF002A";
    ctx.font = "50px Georgia";
    ctx.fillText(text, cw / 2 - cw / 2 / 2, cw / 2 - 30);
    
    // In two-player mode, show the winner
    if (player2Enable && snakes.length > 1 && crashedSnakeIndex >= 0) {
        var winnerIndex = crashedSnakeIndex === 0 ? 1 : 0;
        var winnerColor = snakes[winnerIndex].color;
        var winnerName = winnerColor === '#00FF00' ? 'Green' : 'blue';
        
        ctx.fillStyle = winnerColor;
        ctx.font = "40px Georgia";
        ctx.fillText(winnerName + " WINS!", cw / 2 - cw / 2 / 2, cw / 2 + 30);
    }
}

function drawBackground() {
    ctx.fillStyle = "#000000";
    ctx.fillRect(0, 0, cw, ch);
}

// Handle window resize - disable player 2 if switched to mobile
window.addEventListener('resize', function() {
    if (isMobileView() && player2Enable) {
        player2Enable = false;
        onReset();
    }
});
